var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "help-modal",
          role: "dialog",
          tabindex: "-1",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("\n          Keyboard shortcuts\n        ")
                ]),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row flex-wrap" }, [
                  _c("div", { staticClass: "col-lg-4" }, [
                    _c("h6", [_vm._v("Actions")]),
                    _c("dl", { staticClass: "row" }, [
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("n")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                New Post\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("s")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Star\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("r")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Reply\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("p")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Repost\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("Del")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v(
                          "\n                Delete my post\n              "
                        )
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("Enter")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v(
                          "\n                Go to detail page\n              "
                        )
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [
                          _c("kbd", [_vm._v("Ctrl")]),
                          _vm._v("+"),
                          _c("kbd", [_vm._v("Enter")])
                        ])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Send post\n              ")
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col-lg-4" }, [
                    _c("h6", [_vm._v("Navigation")]),
                    _c("dl", { staticClass: "row" }, [
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("j")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Next post\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("k")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v(
                          "\n                Previous post\n              "
                        )
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v(".")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v(
                          "\n                Load new posts\n              "
                        )
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("?")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                This help\n              ")
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col-lg-4" }, [
                    _c("h6", [_vm._v("Streams")]),
                    _c("dl", { staticClass: "row" }, [
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("h")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Home\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("m")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Mentions\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("i")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Interactions\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("s")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Stars\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("c")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v(
                          "\n                Conversations\n              "
                        )
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("p")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Photos\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("t")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Trending\n              ")
                      ]),
                      _c("dt", { staticClass: "col-4" }, [
                        _c("kbd", [_vm._v("g")]),
                        _vm._v(" "),
                        _c("kbd", [_vm._v("g")])
                      ]),
                      _c("dd", { staticClass: "col-8" }, [
                        _vm._v("\n                Global\n              ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b689b21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b689b21","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/HelpModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2b689b21","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/HelpModal.vue
// module chunks = 0